import { darkColors, lightColors } from "../../theme/colors";

export interface NavThemeType {
  background: string;
}

export const light: NavThemeType = {
  background: lightColors.whiteOpacity8,
};

export const dark: NavThemeType = {
  background: darkColors.whiteOpacity8,
};
